<template>
    <div id="step-header" class="step-header">
        <h3>Krok {{step}}/4</h3>
        <h1 v-if="step !== 2">{{title}}<span class="purple-text">.</span></h1>
    </div>
</template>

<script>
    export default {
        name: "step-header",
        props: ['step', 'title']
    }
</script>